import Vue from "vue";

export default {
  state: () => ({
    active: {}
  }),
  mutations: {
    /**
     * Set a filter on the store
     * @param {*} state
     * @param {*} payload
     */
    setActive(state, payload) {
      // Check there are not more than 10 active filters of type

      // micro optimisation
      const type = payload.type;

      let numOfType = 0;
      for (var i = 0, n = state.active.length; i < n; ++i) {
        if (state.active[i].type === type) {
          ++numOfType;
        }
      }

      if (numOfType < 10) Vue.set(state.active, payload.id, payload);
    },

    /**
     * Remove a filter from the store
     * @param {*} state
     * @param {*} payload
     */
    deleteActive(state, payload) {
      Vue.delete(state.active, payload.id);
    },

    /**
     * Clear all filters from the store
     * @param {*} state
     */
    clearActive(state) {
      state.active = {};
    }
  }
};
